import React from "react";

const Lila = () => {
  return (
    <div className="main-column" style={{ height: '96vh' }}>
    Test
    </div>
  );
};

export default Lila;